import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  MixedWidget1,
  StatsWidget11,
  StatsWidget12,
} from "../../../_metronic/_partials/widgets";
import { StatsWidget13 } from "../../../_metronic/_partials/widgets/stats/StatsWidget13";

export default function B2CDashboard() {
  const {
    user: {
      accessToken,
      refreshToken,
      user: { user_role_id },
    },
  } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(true);
  const [cardData, setCardData] = useState("");
  const [chartData, setChartData] = useState("");

  const getCardData = async () => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/dashboard/dashBoardQuantityAndAmountData`,
      {
        type: "B2C",
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      setCardData(data.data);
      setLoading(false);
    }
  };

  const getChartData = async () => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/dashboard/orderAmountAndCountLastWeekForAllType`,
      {
        type: "B2C",
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );

    if (!data.error) {
      setChartData(data.data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCardData();
    getChartData();
  }, []);

  return (
    <>
      <div className="row">
        {loading ? (
          <>Loading...</>
        ) : (
          user_role_id != 3 && user_role_id != 19 && (
            <>
              <div className="col-lg-12 col-xxl-12">
                <MixedWidget1
                  className="card-stretch gutter-b"
                  data={cardData}
                />
              </div>

              <div className="col-12 col-lg-6 col-xxl-6">
                <StatsWidget11
                  className="card-stretch gutter-b"
                  data={chartData}
                />
              </div>
              <div className="col-12 col-lg-6 col-xxl-6">
                <StatsWidget12
                  className="card-stretch gutter-b"
                  data={chartData}
                />
              </div>
              <div className="col-12 col-lg-12 col-xxl-12">
                <StatsWidget13
                  className="card-stretch gutter-b"
                  data={chartData}
                />
              </div>
            </>
          )
        )}
      </div>
    </>
  );
}
